import React from "react";
import PropTypes from "prop-types";
import CurrencyInput from 'react-currency-input-field';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  ButtonGroup
} from "reactstrap";
import classNames from "classnames";
import { ptBR } from "date-fns/locale";
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isMobile, dateFormatCalender } from '../../helpers/utils'
import { IMPLANTATION_STATUS, FREQUENCY_CHARGE } from '../../configs/constants'

registerLocale("pt-BR", ptBR);

function mountEvent(name,value) {
  return {
    target:{
      name: name,
      value: value,
    }
  };
};

const SubscriptionComponent = ({
  onChange,
  onChangeValue,
  onChangeValueTransfer,
  onChangeValueImplantation,
  onClick,
  onCancel,
  subscription,
  organization,
  onChangeDueDate,
  onChangeStartDate
}) => {
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="title">Comercial</h5>
          </CardHeader>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                onClick();
              }}
            >
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Estabelecimento</label>
                    <Input
                      id="organizationName"
                      name="organizationName"
                      value={subscription?.organizationName}
                      type="text"
                      disabled={true}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <label>Data de início</label>
                    <DatePicker
                      className="form-control"
                      locale="pt-BR"
                      selected={dateFormatCalender(subscription?.startDate)}
                      onChange={onChangeStartDate}
                      dateFormat="dd/MM/yyyy"
                      minDate={new Date()}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <label>Quantidade de Dispositivos</label>
                    <Input
                      id="numberDevices"
                      name="numberDevices"
                      type="number"
                      height={"100px"}
                      value={subscription?.numberDevices}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>       
              </Row>
              <Row>
                 <Col xs={12} md={12}>
                    <FormGroup>
                      <label>Status da importação</label><br/>
                      <ButtonGroup style={{width: "100%"}}>
                        <Button style={{width: "20%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.statusImportation === IMPLANTATION_STATUS.waiting})} outline onClick={()=>onChange(mountEvent("statusImportation", IMPLANTATION_STATUS.waiting))}>Aguardando</Button>
                        <Button style={{width: "20%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.statusImportation === IMPLANTATION_STATUS.file})} outline onClick={()=>onChange(mountEvent("statusImportation", IMPLANTATION_STATUS.file))}>Arquivo</Button>
                        <Button style={{width: "20%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.statusImportation === IMPLANTATION_STATUS.tv})} outline onClick={()=>onChange(mountEvent("statusImportation", IMPLANTATION_STATUS.tv))}>Tv</Button>
                        <Button style={{width: "20%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.statusImportation === IMPLANTATION_STATUS.training})} outline onClick={()=>onChange(mountEvent("statusImportation", IMPLANTATION_STATUS.training))}>Treinamento</Button>
                        <Button style={{width: "20%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.statusImportation === IMPLANTATION_STATUS.delivered})} outline onClick={()=>onChange(mountEvent("statusImportation", IMPLANTATION_STATUS.delivered))}>Entregue</Button>
                      </ButtonGroup>    
                    </FormGroup>
                  </Col>
              </Row>
              <Row>
                 <Col xs={12} md={12}>
                    <FormGroup>
                      <label>Frequência de cobrança</label><br/>
                      <ButtonGroup style={{width: "100%", zIndex: "0"}}>
                        <Button style={{width: "25%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.cycle === FREQUENCY_CHARGE.none})} outline onClick={()=>onChange(mountEvent("cycle", FREQUENCY_CHARGE.none))}>Não cobrar</Button>
                        <Button style={{width: "25%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.cycle === FREQUENCY_CHARGE.monthly})} outline onClick={()=>onChange(mountEvent("cycle", FREQUENCY_CHARGE.monthly))}>Mensal</Button>
                        <Button style={{width: "25%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.cycle === FREQUENCY_CHARGE.biannual})} outline onClick={()=>onChange(mountEvent("cycle", FREQUENCY_CHARGE.biannual))}>Semestral</Button>
                        <Button style={{width: "25%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: subscription?.cycle === FREQUENCY_CHARGE.annual})} outline onClick={()=>onChange(mountEvent("cycle", FREQUENCY_CHARGE.annual))}>Anual</Button>
                      </ButtonGroup>    
                    </FormGroup>
                  </Col>
              </Row>
              {(subscription?.cycle ?? FREQUENCY_CHARGE.none) !== FREQUENCY_CHARGE.none && (
              <Row>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>Valor da mensalidade</label>
                    <CurrencyInput
                        className="form-control"
                        defaultValue={subscription?.valueStr}
                        name="value"
                        decimalsLimit="2"             
                        placeholder="0,00"
                        onChange={onChangeValue}
                    />
                  </FormGroup>
                </Col>              
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>Próximo vencimento</label>
                    <DatePicker
                      className="form-control"
                      locale="pt-BR"
                      selected={dateFormatCalender(subscription?.nextDueDate)}
                      onChange={onChangeDueDate}
                      dateFormat="dd/MM/yyyy"
                      minDate={new Date()}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                  </FormGroup>
                </Col>       
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>Valor da implantação</label>
                    <CurrencyInput
                        className="form-control"
                        defaultValue={subscription?.valueImplantationStr}
                        name="valueImplantation"
                        decimalsLimit="2"             
                        placeholder="0,00"
                        onChange={onChangeValueImplantation}
                    />
                  </FormGroup>
                </Col>  
              </Row>
              )}           
              {(subscription?.cycle ?? FREQUENCY_CHARGE.none) !== FREQUENCY_CHARGE.none && (
              <Row>
                <Col xs={12} md={12}>
                  <FormGroup>
                    <label>Descrição da mensalidade</label>
                     <Input
                      id="description"
                      name="description"
                      height={"100px"}
                      value={subscription?.description}
                      type="textarea"
                      rows="4"
                      readOnly={true}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              )}
              {(subscription?.cycle ?? FREQUENCY_CHARGE.none) === FREQUENCY_CHARGE.none &&
              organization?.type === 2 && (
              <Row>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <label>Valor do repasse</label>
                    <CurrencyInput
                        className="form-control"
                        defaultValue={subscription?.valueTransferStr}
                        name="valueTransfer"
                        decimalsLimit="2"             
                        placeholder="0,00"
                        onChange={onChangeValueTransfer}
                    />
                  </FormGroup>
                </Col>           
              </Row>
              )}
              <Row>
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="danger"
                    type="button"
                    onClick={()=>onCancel()}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Col>
              </Row>                  
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

SubscriptionComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired
};

export default SubscriptionComponent;